import { useStaticQuery, graphql } from 'gatsby'
import { useLocation } from '@reach/router'

const SEO = ({ title, description, image }) => {
  const { directus, site } = useStaticQuery(query)
  const location = useLocation()

  const currentURL = `${site.siteMetadata.siteUrl}${location.pathname}`
  const currentImage = encodeURI(`${site.siteMetadata.siteUrl}${image?.imageFile?.publicURL ?? directus.seo.image.imageFile.publicURL}`)
  const fullTitle = `${title}: Mushroom Color Atlas`

  return (
    <>
      <title>{fullTitle}</title>
      <meta name='description' content={description} />
      <meta property='og:type' content='website' />
      <meta property='og:image' content={currentImage} />
      <meta property='og:image:width' content={image?.width ?? directus.seo.image.width} />
      <meta property='og:image:height' content={image?.height ?? directus.seo.image.height} />
      <meta property='og:url' content={currentURL} />
      <meta property='og:description' content={description} />
      <meta property='og:site_name' content={fullTitle} />

      <meta name='twitter:card' content='summary' />
      <meta name='twitter:site' content='@mushroomcoloratlas' />
      <meta name='twitter:description' content={description} />
      <meta name='twitter:title' content={fullTitle} />
      <meta name='twitter:image' content={currentImage} />
      <meta name='twitter:url' content={currentURL} />

      <meta itemProp='name' content={fullTitle} />
      <meta itemProp='url' content={currentURL} />
      <meta itemProp='description' content={description} />
      <meta itemProp='image' content={currentImage} />
      <meta itemProp='thumbnailUrl' content={currentImage} />
    </>
  )
}

export default SEO

const query = graphql`
  query {
    directus {
      seo {
        image {
          id
          width
          height
          imageFile {
            publicURL
          }
        }
      }
    }
    site {
      siteMetadata {
        siteUrl
      }
    }
  }
`
